module.exports = __webpack_public_path__ + "static/media/V-img3.fdc57ba2.png";